// @flow

import { Container } from "@mui/material";
import MuiComponents from "./muiComponents/muiComponents";

type Props = {};

const TestPage = (props: Props) => {
  return (
    <Container>
      <MuiComponents />
    </Container>
  );
};

export default TestPage;
